function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5728 14.3105C10.2728 14.3105 7.37282 11.2105 7.07282 7.41055C6.97282 5.41055 7.57282 3.61055 8.77282 2.31055C9.97282 1.01055 11.6728 0.310547 13.5728 0.310547C15.4728 0.310547 17.1728 1.01055 18.3728 2.31055C19.5728 3.61055 20.1728 5.41055 20.0728 7.31055C19.7728 11.2105 16.8728 14.3105 13.5728 14.3105ZM13.5728 2.31055C12.2728 2.31055 11.0728 2.81055 10.2728 3.71055C9.37282 4.61055 8.97282 5.91055 9.07282 7.21055C9.27282 10.0105 11.3728 12.3105 13.5728 12.3105C15.7728 12.3105 17.8728 10.0105 18.0728 7.21055C18.1728 5.81055 17.7728 4.61055 16.8728 3.71055C16.0728 2.81055 14.8728 2.31055 13.5728 2.31055Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.5728 28.3105H2.57282C1.97282 28.3105 1.47282 28.1105 1.07282 27.6105C0.672821 27.1105 0.472821 26.5105 0.672821 25.8105C1.77282 19.3105 8.17282 16.3105 13.5728 16.3105C18.9728 16.3105 25.3728 19.3105 26.5728 25.8105C26.6728 26.5105 26.5728 27.1105 26.1728 27.6105C25.6728 28.1105 25.1728 28.3105 24.5728 28.3105ZM13.5728 18.3105C8.97282 18.3105 3.57282 20.8105 2.57282 26.1105C2.57282 26.2105 2.57282 26.3105 2.57282 26.3105H24.5728C24.5728 26.3105 24.5728 26.2105 24.5728 26.1105C23.5728 20.8105 18.1728 18.3105 13.5728 18.3105Z",
  fill: "black"
});

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person.3c01b66f.svg";
export { ForwardRef as ReactComponent };